export default __webpack_public_path__ + "static/PES-mobile-4-4ee114708503c7a59dace4a5a596aa31.jpg";